export default {
  init() {
    let bookWrap = $('.book-wrap');
    if (bookWrap.length) {
      $('.tab', bookWrap).on('click', function (e) {
        e.preventDefault();
        let _this  = $(this);
        let target = _this.attr('href');

        _this.siblings().removeClass('active');
        $(this).addClass('active');

        $(target).siblings().removeClass('active show').fadeOut(100);
        $(target).addClass('active show ').fadeIn(100);
      });
    }
  },
  finalize() {},
};



// WEBPACK FOOTER //
// ./scripts/routes/components/tabs.js